import { createTheme } from '@mui/material/styles';

export default createTheme({
  palette: {
      mode: "dark", 
    primary: {
      main: "#21CE99",
    },
    background:{
        default: "#1A1A1B",
        paper: "#2F2F30"
    },

    warning: {
        main: "#E8444D"
    }
  },
  typography: {
    allVariants: {
      fontFamily: "ProximaNova 'Roboto' sans-serif"
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          fontWeight: 'bold',
          fontSize: "18px",
          padding: "18px 0px",
          borderRadius: "10px"
        },
      },
    },
  },
});
